import { render, staticRenderFns } from "./tableBrand.vue?vue&type=template&id=b2f0bd8c&scoped=true&"
import script from "./tableBrand.vue?vue&type=script&lang=js&"
export * from "./tableBrand.vue?vue&type=script&lang=js&"
import style0 from "./tableBrand.vue?vue&type=style&index=0&id=b2f0bd8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f0bd8c",
  null
  
)

export default component.exports